import React, { Component } from 'react';
import Popup from 'components/popups/popup';
import Youtube from 'react-youtube'
import {isMobile, isIos} from 'helpers/ApplicationHelper';

class PopupVideo extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    _onReady(event) {
        // access to player in all event handlers via event.target
        if(isMobile()){
            event.target.pauseVideo();
        }
        else {
            event.target.playVideo();
        }
    }

    componentWillUnmount() {
        typeof this.props.onClose === 'function' && this.props.onClose();
    }

    content() {
        let mobileOpts = {
            height: '219',
            width: '100%',
            playerVars: {
                autoplay: 0
            }
        };
        let desktopOpts = {
            height: '414',
            width: '736',
            playerVars: {
                autoplay: 1
            }
        };
        return (
            <div>
                <Youtube
                    videoId={this.props.button.videoId}
                    id={this.props.button.label}
                    className=""
                    opts={isMobile() ? mobileOpts : desktopOpts}
                    onReady={this._onReady}
                />
            </div>
        );
    }
}

PopupVideo.defaultProps = {
    popupClassName: 'popup-tooltip popup-video',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

export default PopupVideo;